/*
 * @Descripttion: 仅仅是定义了一些常量 方便统一管理    同时供actionCreators 和 reducer调用
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-06 14:03:09
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-05-11 13:07:18
 */
export default {
  LoginIn: 'LoginIn',
  SaveUser: 'SaveUser',
  LoginOut: 'LoginOut',
  Register: 'Register',
  GetFriendList: 'GetFriendList',
  GetFriendApplication: 'GetFriendApplication',
  AddTalkList: 'AddTalkList',
  DeleteTalkList: 'DeleteTalkList',
  DeleteFriend: 'DeleteFriend',
  AddRoomMessage: 'AddRoomMessage',
  AddRoomUnReadMsg: 'AddRoomUnReadMsg',
  DeleteRoomUnReadMsg: 'DeleteRoomUnReadMsg',
  AddRoomLastMsg: 'AddRoomLastMsg',
  FriendAction: 'FriendAction',
  ChangeRoom: 'ChangeRoom',
  AddUserCache: 'AddUserCache',
  UserName: 'UserName',
  QuestionOne: 'QuestionOne',
  // AnswerOne: 'AnswerOne',
  QuestionTwo: 'QuestionTwo',
  // AnswerTwo: 'AnswerTwo',
  SensingDisplay: 'SensingDisplay',
  SensingDownload: 'SensingDownload',
  ChangeActiveRoomName: 'ChangeActiveRoomName',
  OnlineServiceList: 'OnlineServiceList',
  OnlineServiceId: 'OnlineServiceId',

  ZD_SaveUser: "ZD_SaveUser",
  ProcessProductHideAndShow: "ProcessProductHideAndShow",
  ProcessProduct_SourceInputHideAndShowFlag: "ProcessProduct_SourceInputHideAndShowFlag",
  SetProducerFlowId: 'SetProducerFlowId',
  SetProducerFlow: 'SetProducerFlow',
  SetSourceDataList: 'SetSourceDataList',

  SetResourcePage: 'SetResourcePage',
  SetInsClass: 'SetInsClass',
  SetUserMsg: 'SetUserMsg',
  searchRules02: 'searchRules02',
  ResetTalkList:'ResetTalkList'
}
